import token from './token';
import * as loader from './loader';

export {
  token,
  loader,
};



/** WEBPACK FOOTER **
 ** ./src/helpers/request/interceptors/index.js
 **/